import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

const httpOptionData = {
  headers: new HttpHeaders({
   // 'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
}

@Injectable({
  providedIn: 'root'
})
export class PlanService {

  url = environment.baseUrl+ '/api/plan';

  constructor(private http: HttpClient) {}

  GetPlanesDropDown(): Observable<any> {
    const body = {};
    return this.http.post<any>(this.url + '/GetPlanesDropDown', body, httpOption);
  }

  GetPlanes(empresaId:string): Observable<any> {
    const body = {id:empresaId};
    return this.http.post<any>(this.url + '/GetPlanes', body, httpOption);
  }

  GetPlanesEmpresa(): Observable<any> {
    const body = {};
    return this.http.post<any>(this.url + '/GetPlanesEmpresa', body, httpOption);
  }

  AsignarPlanAEmpresa(planId:string, empresaId:string): Observable<any> {
    const body = {planId, empresaId};
    return this.http.post<any>(this.url + '/AsignarPlanAEmpresa', body, httpOption);
  }

  EliminarPlanAEmpresa(planId:string, empresaId:string): Observable<any> {
    const body = {planId, empresaId};
    return this.http.post<any>(this.url + '/EliminarPlanAEmpresa', body, httpOption);
  }

  AddPlan(obj:any): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/AddPlan', obj, httpOption);
  }

  EditPlan(obj:any): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/EditPlan', obj, httpOption);
  }

}
